import classnames from "classnames";
import React, { JSX, SyntheticEvent } from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

type ProductTileButtonProps = {
    onClick: (e: SyntheticEvent<HTMLButtonElement>) => Promise<void> | void;
    showOutline: boolean;
    children: JSX.Element | JSX.Element[];
    className?: string;
};

const ProductTileButtonComponent = ({
    onClick,
    showOutline,
    children,
    className,
}: ProductTileButtonProps) => {
    const { t } = useGranite();

    return (
        <Button
            fullWidth={false}
            type="button"
            test="productTile-button-order"
            color="primary"
            disabled={showOutline}
            outline={showOutline}
            onClick={onClick}
            className={classnames(className, showOutline && "cursor-default")}
            aria-label={t("accessibility.productTileButton.addToCart")}
        >
            {children}
        </Button>
    );
};

export default ProductTileButtonComponent;
